import { Context, useContext } from 'react';

export const useRequiredContext = <T>(context: Context<T | undefined>) => {
  const ctx = useContext(context);
  if (!ctx)
    throw new Error(`Context ${context.displayName} not defined. Provider is required for context`);
  return ctx;
};
